import styled from "styled-components";
import { Button, Container } from "react-bootstrap";
import { colors, types } from "../../libs";

export const StyledContainer = styled(Container)`
  padding-top: 16px;
  max-width: 1111px;
  position: relative;
  padding-bottom: 0;
  margin-bottom: 0;
`;

export const ContentWrapper = styled.div<{ $showForm: boolean }>`
  position: relative;
  width: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const ListSection = styled.div<{ $showForm: boolean }>`
  width: 100%;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease;
  transform: ${props => props.$showForm ? 'translateX(-100%)' : 'translateX(0)'};
  opacity: ${props => props.$showForm ? '0' : '1'};
  margin-bottom: 0;
  padding-bottom: 0;
  ${props => props.$showForm && `
    position: absolute;
    pointer-events: none;
  `}
`;

export const FormSection = styled.div<{ $showForm: boolean }>`
  width: 100%;
  height: 75vh;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease;
  transform: ${props => props.$showForm ? 'translateX(0)' : 'translateX(100%)'};
  opacity: ${props => props.$showForm ? '1' : '0'};
  ${props => !props.$showForm && `
    position: absolute;
    pointer-events: none;
    height: 0;
    overflow: hidden;
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeftSection = styled.div`
  ${types.headers.itemMedium};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Description = styled.p`
  ${types.body.normal};
  color: ${colors.text.gray};
  margin-top: 16px;
  margin-bottom: 0;
`;

export const DashboardSearchWrapper = styled.div``;

export const SearchBarWrapper = styled.div`
  position: relative;
  width: 254px;
`;

export const SearchInput = styled.input`
  width: 100%;
  border-radius: 20px;
  padding: 8px 50px;
  background: ${colors.background.smokyBlack};
  color: ${colors.text.white};
  border: 1px solid rgba(255, 255, 255, 0.2);
  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 20px;
  top: 14px;
  z-index: 1;
`;

export const OutletsListContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 0;
  padding-bottom: 0;
`;

export const CustomButton = styled(Button)`
  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  &:hover {
    background: ${colors.background.lightGrey};
  }
`;

export const CreateButton = styled(Button)`
  background: ${colors.background.green};
  color: ${colors.text.black};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: none;
  &:hover {
    background: ${colors.background.lightGreen};
  }
`;

export const ErrorMessage = styled.div`
  ${types.body.normal};
  color: ${colors.text.red || '#ff4444'};
  background: rgba(255, 68, 68, 0.1);
  padding: 12px 16px;
  border-radius: 8px;
  margin-top: 16px;
  border-left: 4px solid ${colors.text.red || '#ff4444'};
`;

export const CustomButtonGray = styled(Button)`
  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  padding: 8px 16px; 
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  &:hover {
    background: ${colors.background.lightGrey};
  }
`;